import React from 'react';
import PromoCard from '@boschebike/ebds-react/dist-esm/components/PromoCard.js';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
/**
 * @typedef {import('../../App.d.ts').PromoCardProps} PromoCardProps
 */
/**
 * @param {PromoCardProps} props
 */
export default (props) => {
  return (
    <PromoCard
      data-testid="promo-card"
      headline={props.headline}
      description={props.description}
      badge={props.badge || undefined}
      badgeType={props.badgeType || undefined}
      notification={props.notification || undefined}
      notificationType={props.notificationType || undefined}
      backgroundColor={props.backgroundColor || undefined}
      img={(
        <img
          src={props.image.fields.file.url}
          alt=""
          width={props.image.fields.file.details.image.width}
          height={props.image.fields.file.details.image.height}
        />
      )}
      secondaryButton={
        props.secondaryButton ? (
          <Button
            text={props.secondaryButton.label}
            href={props.secondaryButton.href}
            mode={Button.modes.SECONDARY}
          />
        ) : null
      }
      primaryButton={
        props.primaryButton ? (
          <Button
            text={props.primaryButton.label}
            href={props.primaryButton.href}
            mode={Button.modes.PRIMARY}
          />
        ) : null
      }
    />
  );
};
